import React from 'react';

import { Image, Title, Description } from 'common/components';
import { PlanInformation } from 'common/modules/domain/plan';

interface Props {
  /** 表示するプラン */
  targetPlan: PlanInformation;
}

/**
 * プラン詳細画面のプラン説明のPresentation Component
 */
export const Plan: React.FC<Props> = ({ targetPlan }) => {
  const imageUrl = targetPlan && targetPlan.imageUrl;
  const name = targetPlan && targetPlan.name;
  const description = targetPlan && targetPlan.description;

  const _component = React.useMemo(() => {
    const baseDataTest = 'planDetailPlan';
    return imageUrl && name && description ? (
      <div className="plan borderless" data-test={`${baseDataTest}-borderless`}>
        <Image
          type="icon"
          imageSrc={imageUrl}
          data-test={`${baseDataTest}-image`}
        />
        <div className="info" data-test={`${baseDataTest}`}>
          <Title type="name" data-test={`${baseDataTest}-title`}>
            {name}
          </Title>
          <Description
            type="description"
            data-test={`${baseDataTest}-description`}
          >
            {description}
          </Description>
        </div>
      </div>
    ) : null;
  }, [imageUrl, name, description]);
  return _component;
};
